/* eslint-disable */
// =============================================================================
// Production Plan modal — column visibility resolver.
//
// Pehle yeh ek 180-line inline `.filter()` tha (samajhna mushkil). Ab same logic
// layered, named functions me hai. Behaviour bilkul 1:1 preserved hai.
//
// Resolve order (har column ke liye):
//   1. Recipe Status   -> hide jab API se recipeApprovalStatus map khaali ho
//   2. Customer 73      -> uske 5 columns hide
//   3. LPP whitelist    -> PRODUCT/INTERMEDIATE + lppId par SIRF whitelist columns
//                          (yeh ek override hai, additive exclude nahi)
//   4. Tab + LPP + flags -> baaki sab cases me exclude-set banta hai
//
// ctx = {
//   type,            // 'PRODUCT' | 'INTERMEDIATE' | 'INGREDIENT' | 'PACKAGING'
//   lppId,           // boolean
//   customerId,      // string
//   hasRecipeStatus, // boolean (recipeApprovalStatus map me kuch hai?)
//   hasReasons,      // boolean (reasonList me kuch hai?)
//   isLeftOverCheck, // boolean
//   isA2bCustomer,   // boolean
//   labels: { plannedDate, stockCheckedAt, stockCheckAtDate, nextStockCheckAtDate, scheduledFor },
// }
// =============================================================================

// LPP mode (PRODUCT/INTERMEDIATE) me sirf yahi columns dikhte hain.
// Order Quantity ka title date-stamped hai isliye yeh ab labels (L) leta hai.
// type-aware: Final Production / Recommended Production Qty / Production Factor
// sirf PRODUCT me; Parent Product PRODUCT me hide (sirf non-PRODUCT me).
const lppWhitelist = (L = {}, type) => {
	const isProduct = type === 'PRODUCT';
	return [
		'Product Name',
		'Unit',
		'Category',
		'Sub Category',
		'SKU Code',
		`Order Quantity PO Delivery Date ${L.scheduledFor}`,
		`Stock At ${L.stockCheckedAt}`,
		...(isProduct
			? [
				'Recommended Production Qty',
				'Final Production',
				// LPP PRODUCT tab: Production Factor column ab hide hai.
			]
			: []),
		'Batch Size',
		'Pre Batch Production Quantity',
		'Recipe Exists',
		'Recipe Status',
		'No of batches',
		'Shift Name',
		...(!isProduct ? ['Parent Product'] : []),
		'Select Yield Process',
		'Kit Batch Size',
		'Kit Count',
		'Labelling Date',
		'Scheduled Date',
	];
};

// Customer 73 ke flow me yeh columns kaam ke nahi -> hide.
const customer73Hidden = (L) => [
	`Planned To be Received on ${L.plannedDate}`,
	`Stock At ${L.stockCheckedAt}`,
	`Plan ${L.stockCheckAtDate} Produced till ${L.stockCheckedAt}`,
	`Plan ${L.stockCheckAtDate} Planned Production`,
	`Projected Stock at ${L.nextStockCheckAtDate} 7:59 AM`,
];

// INGREDIENT tab apna pura exclude list rakhta hai (base excludes apply NAHI hote).
const ingredientExcludes = (ctx) => {
	const { lppId, isLeftOverCheck, isA2bCustomer, labels: L } = ctx;
	const ex = [
		'Left Over (Input)',
		'Recipe Exists',
		'Recipe Status',
		'Final Production',
		'Production Factor (+/- Manual Calibration)',
		'Possible Production Qty',
		'Recommended Production Qty',
		`Stock At ${L.stockCheckedAt}`,
		`Plan ${L.stockCheckAtDate} Produced till ${L.stockCheckedAt}`,
		`Plan ${L.stockCheckAtDate} Planned Production`,
		`Projected Stock at ${L.nextStockCheckAtDate} 7:59 AM`,
		`Minimum Stock at ${L.nextStockCheckAtDate} 7:59 AM`,
		`Order Quantity PO Delivery Date ${L.scheduledFor}`,
		'Select Yield Process',
		`Plan ${L.stockCheckAtDate} Planned Extra Production`,
		...(!isLeftOverCheck
			? ['Left Over (From Executed plans)', 'Left Over (Already Planned)']
			: []),
		...(!isA2bCustomer ? ['Measure Quantity'] : []),
		'No of batches',
		'Shift ID',
		'Shift Name',
		// LPP mode me INGREDIENT par Parent Product dikhta hai; baaki jagah hide.
		...(!lppId ? ['Parent Product'] : []),
		'Kit Batch Size',
		'Kit Count',
		'Labelling Date',
		'Scheduled Date',
	];
	if (lppId) {
		ex.push(
			'Scheduled',
			'Forecast for Next 7 Days',
			'Expected Left Over',
			'Required Stock',
			'Current Stock',
			'Status',
			'Pre Batch Without Left Over',
			'Left Over (Used/Input)',
			'Left Over (Already Planned)',
			'Left Over (From Executed plans)'
		);
	}
	// NOTE: INGREDIENT par 'Scheduled' tab tak hide nahi hota jab tak lppId na ho
	// (purane code ka "type !== INGREDIENT -> Scheduled hide" rule yahan apply nahi hota).
	return ex;
};

// PRODUCT / INTERMEDIATE / PACKAGING ke liye exclude set (base + tab + lpp + flags).
const standardExcludes = (ctx) => {
	const { type, lppId, hasReasons, labels: L } = ctx;

	// Base (in teeno me common)
	let ex = [
		'Final Indent',
		'Expected Left Over',
		'From Process',
		'To Process',
		'Pre Batch Without Left Over',
		'Left Over (Input)',
		// Recommended Production Qty sirf LPP flow me dikhana hai.
		'Recommended Production Qty',
	];

	if (type === 'PRODUCT') {
		ex.push(
			'Wastage %',
			'Left Over (From Executed plans)',
			'Left Over (Used/Input)',
			'Left Over (Already Planned)',
			`Plan ${L.stockCheckAtDate} Planned Extra Production`,
			'Stock Info',
			'Required Stock',
			'Current Stock',
			'Measure Quantity',
			`Planned For Consumption ${L.plannedDate}`,
			`Planned To be Received ${L.plannedDate}`,
		);
		if (lppId) {
			ex.push(
				'Parent Product',
				`Order Quantity PO Delivery Date ${L.scheduledFor}`,
				'Forecast for Next 7 Days',
				`Stock At ${L.stockCheckedAt}`,
				`Projected Stock at ${L.nextStockCheckAtDate} 7:59 AM`
			);
		} else {
			ex.push(
				'No of batches',
				'Shift ID',
				'Shift Name',
				'Parent Product',
				'Kit Batch Size',
				'Kit Count',
				'Labelling Date',
				'Scheduled Date'
			);
		}
		if (!hasReasons) ex.push('Reason');
	}

	if (type === 'INTERMEDIATE') {
		ex.push(
			`Stock At ${L.stockCheckedAt}`,
			`Plan ${L.stockCheckAtDate} Produced till ${L.stockCheckedAt}`,
			`Plan ${L.stockCheckAtDate} Planned Production`,
			'Left Over (From Executed plans)',
			'Left Over (Used/Input)',
			'Left Over (Already Planned)',
			'Stock Info',
			'Required Stock',
			'Current Stock',
			'Measure Quantity',
			`Planned For Consumption ${L.plannedDate}`,
			`Planned To be Received on ${L.plannedDate}`
		);
		if (lppId) {
			ex.push(
				'Left Over (Input)',
				`Plan ${L.stockCheckAtDate} Planned Extra Production`,
				`Projected Stock at ${L.nextStockCheckAtDate} 7:59 AM`,
				`Minimum Stock at ${L.nextStockCheckAtDate} 7:59 AM`,
				`Order Quantity PO Delivery Date ${L.scheduledFor}`,
				'Forecast for Next 7 Days'
			);
		} else {
			ex = ex.filter((c) => c !== 'Left Over (Input)');
			ex.push(
				'No of batches',
				'Shift ID',
				'Shift Name',
				'Parent Product',
				'Kit Batch Size',
				'Kit Count',
				'Labelling Date',
				'Scheduled Date'
			);
		}
		if (!hasReasons) ex.push('Reason');
	}

	if (type !== 'PRODUCT' && type !== 'INTERMEDIATE') ex.push('Reason');
	ex.push('Scheduled');

	// Final Production / Production Factor: PRODUCT me hamesha; INTERMEDIATE aur
	// PACKAGING me sirf non-LPP mode me dikhte hain (yeh standardExcludes sirf
	// non-LPP me hi in types par chalta hai, isliye yahan extra guard ki zaroorat
	// nahi). INGREDIENT inhe apne ingredientExcludes me alag se hide karta hai.
	// (Recommended Production Qty base ex me already excluded hai.)

	if (type === 'PACKAGING') {
		ex.push(
			'No of batches',
			'Shift ID',
			'Shift Name',
			'Parent Product',
			'Select Yield Process'
		);
	}

	return ex;
};

export const getProductionPlanColumns = (columns = [], ctx = {}) => {
	const {
		type,
		lppId,
		customerId,
		hasRecipeStatus,
		labels = {},
	} = ctx;

	const lppWhitelistMode =
		lppId && (type === 'PRODUCT' || type === 'INTERMEDIATE');

	const hidden73 = customerId === '73' ? customer73Hidden(labels) : null;
	const lppSet = lppWhitelistMode ? new Set(lppWhitelist(labels, type)) : null;
	const excludeSet = lppWhitelistMode
		? null
		: new Set(
			type === 'INGREDIENT'
				? ingredientExcludes(ctx)
				: standardExcludes(ctx)
		);

	return (columns || []).filter((col) => {
		const title = col?.title;
		if (title === 'Recipe Status' && !hasRecipeStatus) return false;
		if (hidden73 && hidden73.includes(title)) return false;
		if (lppWhitelistMode) return lppSet.has(title);
		return !excludeSet.has(title);
	});
};

// =============================================================================
// Column grouping for the VariantTable-based layout.
//
// Har column ek "parent group" ke neeche aata hai. VariantTable in groups ko
// ek upar wali (grouped) header row me dikhata hai, jisme har group apna color
// define karta hai. Niche order + colors define hain; getColumnGroup() title ko
// uske group se map karta hai; buildVariantTableColumns() filtered columns ko
// VariantTable ke column-shape me convert + group-wise sort karta hai.
// =============================================================================

// Soft, theme-matched pastel backgrounds with a darker text of the same hue —
// keeps the grouped header professional and readable.
export const PP_GROUPS = {
	CORE: {
		label: 'CORE IDENTITY',
		color: '#f1f5f9',
		textColor: '#334155',
	},
	PROCESS: {
		label: 'PROCESS & RECIPE INFORMATION',
		color: '#ecfeff',
		textColor: '#0e7490',
	},
	PLANNING: {
		label: 'PLANNING INFORMATION',
		color: '#eef2ff',
		textColor: '#4338ca',
	},
	INVENTORY: {
		label: 'INVENTORY & STOCK STATUS',
		color: '#eff6ff',
		textColor: '#1d4ed8',
	},
	PRODUCTION: {
		label: 'PRODUCTION PLANNING',
		color: '#f5f3ff',
		textColor: '#6d28d9',
	},
	PROCUREMENT: {
		label: 'PROCUREMENT / ORDERS',
		color: '#ecfdf5',
		textColor: '#047857',
	},
	MANUAL: {
		label: 'MANUAL PRODUCTION ENTRY',
		color: '#fffbeb',
		textColor: '#b45309',
	},
	KIT: {
		label: 'KIT INFORMATION',
		color: '#fdf2f8',
		textColor: '#be185d',
	},
	AUDIT: {
		label: 'AUDIT / STATUS',
		color: '#fafaf9',
		textColor: '#57534e',
	},
};

// Render order of the groups (left -> right). Columns are sorted into these
// buckets (stable within a bucket) so each group renders as one contiguous span.
const GROUP_ORDER = [
	'CORE',
	'PROCESS',
	'PLANNING',
	'INVENTORY',
	'PRODUCTION',
	'PROCUREMENT',
	'MANUAL',
	'KIT',
	'AUDIT',
];

// Static title -> group key. Dynamic (date-stamped) titles are matched by
// prefix in getGroupKey() below.
const STATIC_GROUP = {
	// 1. CORE IDENTITY
	'Product Name': 'CORE',
	'SKU Code': 'CORE',
	Category: 'CORE',
	'Sub Category': 'CORE',
	Unit: 'CORE',
	'Measure Quantity': 'CORE',
	'Parent Product': 'CORE',
	'Item Name': 'CORE',
	'Item Code': 'CORE',
	'Pack Size': 'CORE',
	// 2. PROCESS & RECIPE INFORMATION
	'From Process': 'PROCESS',
	'To Process': 'PROCESS',
	'Select Yield Process': 'PROCESS',
	'Recipe Exists': 'PROCESS',
	'Recipe Status': 'PROCESS',
	'Wastage %': 'PROCESS',
	// 3. PLANNING INFORMATION
	Scheduled: 'PLANNING',
	'Shift ID': 'PLANNING',
	'Shift Name': 'PLANNING',
	'Scheduled Date': 'PLANNING',
	// 4. INVENTORY & STOCK STATUS
	'Current Stock': 'INVENTORY',
	'Required Stock': 'INVENTORY',
	'Expected Left Over': 'INVENTORY',
	'Available Packs in Stock': 'INVENTORY',
	// 5. PRODUCTION PLANNING
	'Recommended Production Qty': 'PRODUCTION',
	'Possible Production Qty': 'PRODUCTION',
	'Pre Batch Production Quantity': 'PRODUCTION',
	'Pre Batch Without Left Over': 'PRODUCTION',
	'Forecast for Next 7 Days': 'PRODUCTION',
	'Production Factor (+/- Manual Calibration)': 'PRODUCTION',
	'Qty of SKU required': 'PRODUCTION',
	'Packs to be packed': 'PRODUCTION',
	// 7. MANUAL PRODUCTION ENTRY
	'Recommended Qty': 'MANUAL',
	'Planned Qty': 'MANUAL',
	'Batch Size': 'MANUAL',
	'Final Production': 'MANUAL',
	'No of batches': 'MANUAL',
	'Final Indent': 'MANUAL',
	'Packs Ordered': 'MANUAL',
	// 8. KIT INFORMATION
	'Kit Batch Size': 'KIT',
	'Kit Count': 'KIT',
	'Labelling Date': 'KIT',
	// 9. AUDIT / STATUS
	Reason: 'AUDIT',
	Status: 'AUDIT',
};

const getGroupKey = (title = '') => {
	if (STATIC_GROUP[title]) return STATIC_GROUP[title];
	// Dynamic, date-stamped titles (matched by prefix).
	// PLANNING — note these start with "Planned " and must be checked before
	// the "Plan " (PRODUCTION) prefix.
	if (
		title.startsWith('Planned For Consumption') ||
		title.startsWith('Planned To be Received')
	) {
		return 'PLANNING';
	}
	// INVENTORY
	if (
		title.startsWith('Stock At') ||
		title.startsWith('Projected Stock at') ||
		title.startsWith('Minimum Stock at') ||
		title.startsWith('Left Over')
	) {
		return 'INVENTORY';
	}
	// PRODUCTION — "Plan <date> Produced/Planned ..." columns.
	if (title.startsWith('Plan ')) return 'PRODUCTION';
	// PROCUREMENT / ORDERS
	if (title.startsWith('Order Quantity PO Delivery Date')) return 'PROCUREMENT';
	return 'CORE';
};

// Public helper: title -> { label, color, textColor } for the group.
export const getColumnGroup = (title) => PP_GROUPS[getGroupKey(title)];

const DEFAULT_COLUMN_WIDTH = 130;

// Convert the filtered column list ([{ title, fixed?, width?, sortable? }]) into
// the shape VariantTable expects, sorted so each group is contiguous. `fixed`,
// `width` and `sortable` are read straight off the column definition (same as
// VariantTable callers like PurchaseRequestList) — only the group metadata is
// added here.
export const buildVariantTableColumns = (columns = []) => {
	return (columns || [])
		.map((col, originalIndex) => {
			const groupKey = getGroupKey(col?.title);
			const group = PP_GROUPS[groupKey];
			return {
				key: col?.title,
				title: col?.title,
				group: group?.label,
				groupColor: group?.color,
				groupTextColor: group?.textColor,
				// All CORE IDENTITY columns stay pinned to the left; CORE renders
				// first so these stay contiguous at the start of the row.
				fixed: !!col?.fixed || groupKey === 'CORE',
				sortable: !!col?.sortable,
				width: col?.width ?? DEFAULT_COLUMN_WIDTH,
				_groupRank: GROUP_ORDER.indexOf(groupKey),
				_originalIndex: originalIndex,
			};
		})
		.sort((a, b) => {
			if (a._groupRank !== b._groupRank) return a._groupRank - b._groupRank;
			return a._originalIndex - b._originalIndex;
		});
};

export default getProductionPlanColumns;
